<template>
    <section class="breadcrumbs">
        <div class="container">
            <ul class="breadcrumbs__list">
                <li 
                    v-for="link in props.breadcrumbs"
                    class="breadcrumbs__item">
                    <NuxtLink 
                        v-if="link.url"
                        :to="link.url">
                        {{ link.title }}
                    </NuxtLink>
                    <span v-else>{{ link.title }}</span>
                    <span v-if="link.url">/</span>
                </li>
            </ul>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
breadcrumbs: {
    type: Array,
    required: true,
  }
})
</script>